/**
 * Clamps
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides the application store to store all geometry related data.
 * This includes information about clam and stand approval of certain points.
 */
export default {
  state: {
    clampApproval: [],
    standApproval: [],
    showCenterDistance: false,
  },
  mutations: {
    SET_CLAMP_APPROVAL(currentState, payload) {
      if (payload.index > currentState.clampApproval.length - 1) {
        currentState.clampApproval.push({ ...payload.data });
      } else {
        currentState.clampApproval = currentState.clampApproval.map((approval, index) => {
          if (payload.index === index) {
            return { ...approval, ...payload.data };
          }
          return approval;
        });
      }
    },
    SET_STAND_APPROVAL(currentState, payload) {
      if (payload.index > currentState.standApproval.length - 1) {
        currentState.standApproval.push({ ...payload.data });
      } else {
        currentState.standApproval = currentState.standApproval.map((approval, index) => {
          if (payload.index === index) {
            return { ...approval, ...payload.data };
          }
          return approval;
        });
      }
    },
    SET_SHOW_CENTER_DISTANCE(currentState, payload) {
      currentState.showCenterDistance = payload;
    },
  },
  actions: {
    setClampApproval(context, payload) {
      context.commit('SET_CLAMP_APPROVAL', payload);
    },
    setStandApproval(context, payload) {
      context.commit('SET_STAND_APPROVAL', payload);
    },
    setShowCenterDistance(context, payload) {
      context.commit('SET_SHOW_CENTER_DISTANCE', payload);
    },
  },
  getters: {
    clampApproval(state) {
      return state.clampApproval;
    },
    standApproval(state) {
      return state.standApproval;
    },
    showCenterDistance(state) {
      return state.showCenterDistance;
    },
  },
};
